import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { CoachGuideCategoryList } from './CoachGuideCategoryList';
import { CoachGuideCategoryDatagrid } from './CoachGuideCategoryDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { CoachGuideCategory } from './CoachGuideCategory';

export * from './CoachGuideCategory';
export * from './CoachGuideCategoryCreate';
export * from './CoachGuideCategoryDatagrid';
export * from './CoachGuideCategoryEdit';
export * from './CoachGuideCategoryList';
export * from './CoachGuideCategoryShow';

const CoachGuideCategoriesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'name', header: 'Name' },
	{ key: 'organization.name', header: 'Organization Name' }
];

export const CoachGuideCategoriesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: CoachGuideCategory) => entity;

	const recipeCategoriesFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('קטגוריות לימודי מאמן', exportFields, exportDataMapper)}
				{...props}
				filters={recipeCategoriesFilter}
				bulkActionButtons={<CoachGuideCategoriesBulkActionButtons/>}
				title="COACH_GUIDE_CATEGORIES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <CoachGuideCategoryList/> : <CoachGuideCategoryDatagrid/>}
			</List>
		</Fragment>
	);
};
